'use client';

import { Box, Container, Flex, Stack, useMantineTheme } from '@mantine/core';
import Footer from './components/ui/Footer';
import Header from './components/ui/Header';
import Features from './components/ui/Features';
import Hero from './components/ui/Hero';
import { useStableColorScheme } from '../lib/use-stable-color-scheme';

export default function WelcomePage() {
  const theme = useMantineTheme();
  const colorScheme = useStableColorScheme();
  const pageGradient = colorScheme === 'dark' ? theme.other.pageGradientDark : theme.other.pageGradientLight;

  return (
    <Box component="main" mih="100vh" style={{ background: pageGradient }}>
      <Stack gap={0} mih="100vh">
        <Header showAuthButton />

        <Flex component="section" px={{ base: 'md', sm: 'xl' }} py={{ base: 'lg', sm: 'xl' }} flex={1} align="center">
          <Container size="md" px={0}>
            <Stack gap="xl" align="center">
              <Hero />
              <Features />
            </Stack>
          </Container>
        </Flex>

        <Footer />
      </Stack>
    </Box>
  );
}
